// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1WvTY","header":"ReportDetails_header__1NYcr","title":"ReportDetails_title__2ZSYJ","left":"ReportDetails_left__38vDW"};